import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "repositorySdgs",
  initialState: {
    list: [],
    count: 0,
  },
  reducers: {
    setRepositorySdgs: (state, { payload: list }) => {
      return {
        ...state,
        list,
      };
    },
    countRepositorySdgs: (state, { payload: count }) => {
      return {
        ...state,
        count,
      };
    },
  },
});

export const { setRepositorySdgs, countRepositorySdgs } = slice.actions;
export default slice.reducer;

export const getRepositorySdgsSelector = (store) => store.repositorySdgs.list;
export const getRepositorySdgsCountSelector = (store) =>
  store.repositorySdgs.count;
